export const DEFAULT_WISTIA_OPTIONS = {
  options: {
    controlsVisibleOnLoad: true,
    smallPlayButton: true,
    playButton: true,
    playbar: true,
    settingsControl: true,
    volumeControl: true,
    silentAutoPlay: false,
    playbackRateControl: true,
    qualityControl: true,
    fullscreenButton: true,
    resumable: false,
  },
};
